import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAnalyticsCurrentView, updateAnalyticsDuration } from "store/actions/analytics";

import { formatDate } from "utils/utils";
import { CHART_HEADER_ACTIONS } from "constants/chartConstant";
import { AnalyticsStrings, ChartStrings, DROPDOWN_STRINGS } from "constants/constantStrings";
import { ANALYTICS_MAX_DAYS_DURATION, LOCAL_TZ_CODE } from "constants/globalConstants";

import CHART_HEADER_BUTTONS from "pages/Chart/ChartHeader/ChartHeader.buttons";
import BadgeLabel from "components/BadgeLabel";
import DatePopover from "components/DatePopover/DatePopover";
import Dropdown from "components/Dropdown";
import DupontIconButton from "components/DupontIconButton";
import ScreenStatusBox from "components/ScreenStatusBox";
import AnalyticsActions from "store/actions/analytics"
import { ANAYTICS_CHART_DURATIONS } from "../AnalyticsHelper/Analytics.const";

const AnalyticsHeader = () => {
  const dispatch = useDispatch();
  const { Duration, DurationRanges, TagsWithoutData, IsLoading, Alarms } = useSelector(state => state.analyticsData);
  const [durationMsg, setDurationMsg] = useState();
  const [popoverAnchor, setPopoverAnchor] = useState();
  const [noDataErrorMsg, setNoDataErrorMsg] = useState("");

  const divRef = useRef();

  useEffect(() => {
    if (TagsWithoutData.length) {
      const TAG_NAME_MAX_LENGTH = 50;
      const tagItems = TagsWithoutData.map(({ TagName }) => TagName);
      let tagsListNames = tagItems.join(", ");
      if (tagsListNames.length >= TAG_NAME_MAX_LENGTH) {
        tagsListNames = `${tagsListNames.slice(0, TAG_NAME_MAX_LENGTH)}...`;
      }
      const msg = ChartStrings.tagsWithNoData.replace("[%]", tagsListNames);
      setNoDataErrorMsg(msg);
    } else {
      setNoDataErrorMsg("");
    }
  }, [TagsWithoutData]);

  useEffect(() => {
    if (DurationRanges) {
      const startDate = formatDate(DurationRanges.startTime * 1000);
      const endDate = formatDate(DurationRanges.endTime * 1000);
      const durationMsg = `${Duration} (${startDate} to ${endDate} ${LOCAL_TZ_CODE})`;
      setDurationMsg(durationMsg);
    }
  }, [DurationRanges]);

  const handleDateRangeChange = Duration => {
    if (Duration && Duration !== "Custom") {
      dispatch(updateAnalyticsDuration({ Duration }));
      dispatch(AnalyticsActions.resetSpikeLine(false));
    }
  };

  const onCustomDateChange = date => {
    if (date && date.startDate && date.endDate) {
      const updateData = {
        Duration: "Custom",
        DurationRanges: {
          startTime: date.startDate.unix(),
          endTime: date.endDate.unix()
        }
      };
      dispatch(updateAnalyticsDuration(updateData));
      dispatch(AnalyticsActions.resetSpikeLine(false));
    }
  };
  const datePopoverHandler = data => setPopoverAnchor(data);

  const onCustomRangeSelection = () => setPopoverAnchor(divRef.current);

  const optionClickHandler = event => {
    const clickedOption = event.target.id;
    setPopoverAnchor(null);
    if (clickedOption === "Custom") {
      setTimeout(() => onCustomRangeSelection(), 100); // Added timeout to fix issue when custom was selected and again selecting custom
    }
  };

  const timeRenderOption = option => (
    <div className="fullWidth" onClick={optionClickHandler} id={option}>
      {option}
    </div>
  );

  const alarmBtnClickHandler = () => dispatch(setAnalyticsCurrentView(CHART_HEADER_ACTIONS.EDIT_ALARMS));

  const getEditButton = type => {
    const iconProps = { name: type, tooltip: AnalyticsStrings[type], disabled: Alarms.length === 0 };
    return (
      <DupontIconButton {...iconProps} onClick={alarmBtnClickHandler}>
        {React.createElement(CHART_HEADER_BUTTONS[type], { ...iconProps })}
      </DupontIconButton>
    );
  };
  const errorNotificationClickHandler = data => setNoDataErrorMsg(data);
  const tagsErrorHoverMsg = () => TagsWithoutData.map(({ TagName }) => TagName).join(", ");

  return (
    <>
      <div className="chart-header">
        {noDataErrorMsg && (
          <ScreenStatusBox type="error" message={noDataErrorMsg} onClose={errorNotificationClickHandler} tooltip={tagsErrorHoverMsg()} />
        )}
        <div className="d-flex">
          <div id="chart-daterange-container" className="chart-header--drop-down">
            <Dropdown
              dropdownRef={divRef}
              labelText={AnalyticsStrings.dateRange}
              value={Duration}
              disabled={IsLoading}
              options={Object.keys(ANAYTICS_CHART_DURATIONS)}
              getOptionLabel={option => option}
              onChange={handleDateRangeChange}
              renderOption={timeRenderOption}
              placeholder={DROPDOWN_STRINGS.chooseOptionStr}
            />
            {popoverAnchor && (
              <DatePopover
                page="Chart"
                setSelectedStartEndDates={onCustomDateChange}
                popoverAnchor={popoverAnchor}
                setPopoverAnchor={datePopoverHandler}
                maxDays={ANALYTICS_MAX_DAYS_DURATION}
              />
            )}
          </div>
          {!IsLoading && (
            <div id="plot-type-container" className="chart-header__plot-types">
              <label className="dupont-form-label">{AnalyticsStrings.editDetails}</label>
              <div className="d-flex">
                <span className="alarm-icon-padding">{getEditButton("EDIT_ALARMS")}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="chart-header--drop-down--date-label cip-note-container">
        <BadgeLabel badgeText={durationMsg} />
        <div className="descriptionText note-item">{AnalyticsStrings.CIP_NOTE}</div>
      </div>
    </>
  );
};
export default AnalyticsHeader;
